
import { makeStyles } from 'tss-react/mui';
import { ActionItemStatus, ProviderActivationEventName } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';
import { useL10n } from '@uplift/hooks';
import { Card } from '@uplift/icons';
import { useProviderActivationEvents } from '@uplift/queries';
import { LinkDashboardActionItem, Tooltip } from '@uplift/ui-v2';

import { hasEvent } from '../../helpers';
import { SelectStatesModal } from '../../pages';
import { useSharedStyles } from '../../styles';

export type SelectStatesProps = {
  status: ActionItemStatus;
  isSelectStatesModalOpen: boolean;
  setIsSelectStatesModalOpen: (show: boolean) => void;
  handleCloseModal: () => void;
};

export const SelectStates: React.VFC<SelectStatesProps> = ({ status, isSelectStatesModalOpen, setIsSelectStatesModalOpen, handleCloseModal }) => {
  const l10n = useL10n();
  const { classes: sharedClasses } = useSharedStyles();
  const { classes } = useStyles();

  const me = useCurrentuser();
  const { data: events } = useProviderActivationEvents(me?.id);
  const isCredentialingApproved = hasEvent(events, ProviderActivationEventName.credentialingApproved);
  const isStateSelectionDisabled = !isCredentialingApproved;

  if (status === ActionItemStatus.todo) {
    return (
      <>
        {isSelectStatesModalOpen && <SelectStatesModal closeModal={handleCloseModal} />}
        <Tooltip
          disableHoverListener={!isStateSelectionDisabled}
          title="Available once approved by credentialing"
          placement="top"
          arrow={false}
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [ 0, -30 ]
                  }
                }
              ]
            }
          }}
        >
          <div>
            <LinkDashboardActionItem
              title={l10n.dashboard.actionItems.stateSelection.title}
              body={l10n.dashboard.actionItems.stateSelection.subtitle}
              bodyClassName={!isStateSelectionDisabled && sharedClasses.actionItemSubtitle}
              color={isStateSelectionDisabled ? 'default' : 'danger'}
              icon={<Card />}
              link="#"
              actionText={l10n.providerSettings.onboarding.selectStates}
              onClick={()=> setIsSelectStatesModalOpen(!isSelectStatesModalOpen)}
              className={isStateSelectionDisabled && classes.disabledActionItem}
            />
          </div>
        </Tooltip>
      </>
    );
  }
  return null;
};

const useStyles = makeStyles()(theme => ({
  disabledActionItem: {
    color: theme.palette.text.disabled,
    cursor: 'not-allowed',
    '& a': {
      pointerEvents: 'none',
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.text.disabled,
    },
  },
}));
